import CloseButtonModal from '../../../../ui/close-button-modal'
import PreviewDetailsData from '../../../proposal-status/modal/preview-proposal-data/preview-details-data'
import { selectAmendmentModalOne, selectedRequestAmendment, setAmendmentModal, setAmendmentModalOne, setNotesReason, setProposalIdAmendment, setSelectedRequestAmendment, setSubAmendmentModal } from '../../../../../features/actuarial/request-amendment/request-amendment.slice'
import { useDispatch, useSelector } from 'react-redux'
import NotesAmendmentConfirmation from '../../../proposal-status/modal/notes-amendment-confirmation'
import { useRequestAmendment } from '../../../../../hooks/actions/use-request-amendment-actions'
import ConfirmDefaultModal from '../../../../global/modal/confirm-default-modal'

export default function RequestAmendmentModal() {

    const dispatch = useDispatch()
    const requestAmendmentData = useSelector(selectedRequestAmendment)
    const amendmentModalOne = useSelector(selectAmendmentModalOne)
    const { handleAccentRequestAmendment, handleDeclineRequestAmendment, isLoadingDeclineRequestAmendment, isLoadingAcceptRequestAmendment } = useRequestAmendment()
    const isLoading = isLoadingDeclineRequestAmendment || isLoadingAcceptRequestAmendment
    
    const handleIsDecline = () => {
        dispatch(setNotesReason(''))
        dispatch(setAmendmentModalOne('isDeclineAmendmentRequest'))
    }

    const handleIsAccept = () => {
        dispatch(setNotesReason(''))
        dispatch(setAmendmentModalOne('isAcceptAmendmentRequest'))
    }

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-3 backdrop-blur-[1px] sm:p-4">
            <div className="flex h-fit w-full sm:max-w-[95vw] lg:max-w-[700px] xl:max-w-[800px] flex-col overflow-hidden rounded-xl border border-gray-200 bg-white shadow-xl">
                {/* Header */}
                <div className="flex shrink-0 items-start justify-between gap-4 border-b border-gray-100 px-4 py-3 sm:px-5">
                    <div className="min-w-0">
                        <div className="flex items-center gap-2">
                            <h2 className="truncate text-sm font-semibold text-gray-800">
                                Request Amendment Details
                            </h2>
                        </div>
                        <p className="text-xs leading-relaxed text-gray-500">
                            Review the requested changes and proposal information.
                        </p>
                    </div>
                    <CloseButtonModal handleClose={() => {
                        dispatch(setAmendmentModal(null))
                        dispatch(setProposalIdAmendment(null))
                        dispatch(setSelectedRequestAmendment(null))
                    }} />
                </div>
                {/* Scrollable Content */}
                <div className="min-h-0 flex-1 overflow-y-auto p-4 sm:p-5">
                    <div className="space-y-5">
                        {/* Request Information */}
                        <section>
                            <div className="mb-2 flex items-center gap-2">
                                <span className="h-1.5 w-1.5 rounded-full bg-[#186cb2]" />
                                <p className="text-xs font-semibold uppercase tracking-wide text-gray-700">
                                    Request Information
                                </p>
                            </div>
                            <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-3">
                                <PreviewDetailsData
                                    title="Proposal as"
                                    value={requestAmendmentData?.proposal_status_name ?? ''}
                                    iconType={5}
                                />
                                <PreviewDetailsData
                                    title="Proposal type"
                                    value={requestAmendmentData?.type_of_proposal_name ?? ''}
                                    iconType={5}
                                />
                                <PreviewDetailsData
                                    title="Product"
                                    value={requestAmendmentData?.plan_name ?? ''}
                                    iconType={6}
                                />
                                <PreviewDetailsData
                                    title="Amendment status"
                                    value={requestAmendmentData?.amendment_status ?? ''}
                                    iconType={9}
                                />
                                <PreviewDetailsData
                                    title="Requested by"
                                    value={requestAmendmentData?.requester_name ?? ''}
                                    iconType={8}
                                />
                            </div>
                        <div className="mt-3 flex items-center justify-between gap-3 rounded-lg border border-[#186cb2]/15 bg-[#186cb2]/5 p-3">
                                <div className="flex min-w-0 items-center gap-2.5">
                                    <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-white text-[#186cb2] shadow-sm">
                                        <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" >
                                            <path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6-10-6-10-6Z" />
                                            <circle cx="12" cy="12" r="2.5" />
                                        </svg>
                                    </div>
                                    <div className="min-w-0">
                                        <p className="text-xs font-semibold text-gray-700">
                                            Proposed Data
                                        </p>
                                        <p className="truncate text-[10px] text-gray-500">
                                            View the proposal data submitted with this amendment.
                                        </p>
                                    </div>
                                </div>
                                <button
                                    type="button"
                                    onClick={() => dispatch(setSubAmendmentModal('viewProposeData'))}
                                    className="flex shrink-0 items-center gap-1.5 rounded-md bg-[#186cb2] px-3 py-2 text-[11px] font-medium text-white transition-colors hover:bg-[#155b96] disabled:cursor-not-allowed disabled:opacity-50"
                                >
                                    <>
                                        <svg className="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" >
                                            <path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6-10-6-10-6Z" />
                                            <circle cx="12" cy="12" r="2.5" />
                                        </svg>
                                        View Proposed Data
                                    </>
                                </button>
                            </div>
                        </section>
                        <section>
                            <div className="mb-2 flex items-center justify-between gap-3">
                                <div>
                                    <p className="text-xs font-semibold text-gray-700">
                                        Amendment Notes
                                    </p>
                                    <p className="mt-0.5 text-[11px] text-gray-500">
                                        Requested changes or additional instructions.
                                    </p>
                                </div>
                            </div>
                            <div className="rounded-lg border border-gray-200 bg-gray-50 p-2">
                                <textarea
                                    rows={6}
                                    readOnly
                                    value={requestAmendmentData?.request_notes ?? ''}
                                    className="w-full resize-none bg-transparent px-2 py-1 text-xs leading-relaxed text-gray-600 outline-none"
                                />
                            </div>
                        </section>
                    </div>
                </div>
                {/* Footer */}
                <div className="flex shrink-0 flex-col-reverse gap-2 border-t border-gray-100 bg-gray-50/70 px-4 py-3 sm:flex-row sm:justify-end sm:px-5">
                    <button type="button" disabled={isLoading} onClick={handleIsDecline} className="flex w-full items-center justify-center gap-2 rounded-md border border-red-200 bg-white px-4 py-2 text-xs font-medium text-red-600 transition-colors hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-50 sm:w-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                        </svg>
                        Decline
                    </button>
                    <button type="button" disabled={isLoading} onClick={handleIsAccept} className="flex w-full items-center justify-center gap-2 rounded-md bg-[#186cb2] px-4 py-2 text-xs font-medium text-white transition-colors hover:bg-[#155b96] disabled:cursor-not-allowed disabled:opacity-50 sm:w-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path strokeLinecap="round" strokeLinejoin="round" d="m5 13 4 4L19 7" />
                        </svg>
                        Accept Request
                    </button>
                </div>
            </div>
            {amendmentModalOne === 'isDeclineAmendmentRequest' && (
                <NotesAmendmentConfirmation
                    modalTitle="Decline Amendment Request"
                    modalSubTitle="Provide an optional note before declining this amendment request."
                    confirmTitle={`Continue Decline`}
                    onCancel={() => {
                        dispatch(setAmendmentModalOne(null))
                        dispatch(setNotesReason(''))
                    }}
                    onConfirm={handleDeclineRequestAmendment}
                    isLoading={isLoading}
                    type='decline'
                />
            )}
            {amendmentModalOne === 'isAcceptAmendmentRequest' && (
                <ConfirmDefaultModal
                    modalTitle="Accept Amendment Request"
                    modalSubTitle="Are you sure you want to accept this amendment request?"
                    onCancel={() => {
                        dispatch(setAmendmentModalOne(null))
                        dispatch(setNotesReason(''))
                    }}
                    onConfirm={handleAccentRequestAmendment}
                    isLoading={isLoading}
                />
            )}
        </div>
    )
}
